module.exports = __webpack_public_path__ + "img/01.5adcada7.jpg";